// extracted by mini-css-extract-plugin
module.exports = {"loaderContainer":"styles_loaderContainer__1ScYu"};